export default "__VITE_ASSET__CoSSzI4X__"